import React from 'react';
import { useDispatch } from 'react-redux';
import { ExternalLink, Phone, X } from 'lucide-react';
import { openPatientDetail } from '../ui/detailPanelSlice';
import SnoozeMenu from './SnoozeMenu';

/** One matching person in a column: who they are, why they're here, and how to act on them. */
export default function ColumnRow({ row, columnId, actions }) {
  const dispatch = useDispatch();

  const open = () => {
    // Patients open in the shared overlay so the board's date and scroll survive; leads still
    // navigate, since no lead overlay exists yet.
    if (row.entityKind === 'Patient' && row.entityId) { dispatch(openPatientDetail(row.entityId)); return; }
    if (row.route) window.location.assign(row.route);
  };

  return (
    <div className="k-card col-row">
      <div className="col-row-main" onClick={open} role="button" tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter') open(); }}>
        <div className="k-card-name">
          {row.fullName}
          {row.patientCode && (
            <span className="td-muted td-mono" style={{ fontWeight: 400, fontSize: '0.7rem', marginLeft: 6 }}>
              {row.patientCode}
            </span>
          )}
        </div>
        <div className="k-card-row">{row.contextLine}</div>
        {row.phone && (
          <div className="k-card-row"><Phone size={11} /> <span className="td-mono">{row.phone}</span></div>
        )}
      </div>

      <div className="col-row-actions">
        {row.phone && (
          <a
            className="btn-icon-sm"
            href={`tel:${row.phone}`}
            title="Call"
            onClick={(e) => e.stopPropagation()}
          >
            <Phone size={13} />
          </a>
        )}
        {row.route && (
          <button className="btn-icon-sm" title="Open record" onClick={(e) => { e.stopPropagation(); open(); }}>
            <ExternalLink size={13} />
          </button>
        )}
        <SnoozeMenu
          onSnooze={(days) => actions.dismiss(columnId, row.matchToken, days)}
          onDismiss={() => actions.dismiss(columnId, row.matchToken, null)}
        />
        <button
          className="btn-icon-sm"
          title="Dismiss from this column"
          onClick={(e) => { e.stopPropagation(); actions.dismiss(columnId, row.matchToken, null); }}
        >
          <X size={13} color="var(--red-500)" />
        </button>
      </div>
    </div>
  );
}
